import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { config } from '../../common/';
import * as Tyre from '../../tyre';

const BaseLayout: React.FC<{}> = () => (
    <Route
        render={() => {
            return (
                <React.Fragment>
                    <Switch>
                        <Route exact path={[`${config.BaseURL}/tyre/simulator`, `${config.AlternativeBaseURL}/tyre/simulator`]} component={Tyre.SimulatorLayout} />
                        <Route exact path={[`${config.BaseURL}/tyre/contact`, `${config.AlternativeBaseURL}/tyre/contact`]} component={Tyre.ContactLayout} />
                        <Route path={[`${config.BaseURL}/tyre/contact/confirm`, `${config.AlternativeBaseURL}/tyre/contact/confirm`]} component={Tyre.ContactConfirm} />
                    </Switch>
                </React.Fragment>
            );
        }}
    />);

export default BaseLayout;
